import 'bootstrap/dist/css/bootstrap.min.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'glightbox/dist/css/glightbox.min.css'
import 'aos/dist/aos.css'
import 'nice-select2/dist/css/nice-select2.css'

import '@/assets/scss/main.scss'
import type { GatsbyBrowser } from 'gatsby'

// Comprehensive scroll restoration fix for Gatsby
// This addresses timing issues with content loading and rehydration

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({ routerProps: { location } }) => {
  // If navigating to the same page (e.g., anchor links), use browser default
  if (location.hash) {
    return true
  }

  // For all other navigation, scroll to top
  // Using requestAnimationFrame ensures it happens after DOM updates
  window.requestAnimationFrame(() => {
    window.scrollTo(0, 0)
  })

  return false
}

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location, prevLocation }) => {
  // Skip if it's the same page or has a hash (anchor link)
  if (location.hash || location.pathname === prevLocation?.pathname) {
    return
  }

  // Multiple scroll attempts to handle async content and rehydration
  // Immediate scroll
  window.scrollTo(0, 0)

  // Using requestAnimationFrame for better timing with browser rendering
  window.requestAnimationFrame(() => {
    window.scrollTo(0, 0)

    // Final scroll after a short delay to catch any late-loading content
    setTimeout(() => {
      window.scrollTo(0, 0)

      // Refresh GSAP ScrollTrigger after route update
      // This ensures animations work correctly on navigation
      if (typeof window !== 'undefined' && (window as any).ScrollTrigger) {
        (window as any).ScrollTrigger.refresh()
      }
    }, 50)
  })
}

// Handle initial page load and force refresh
export const onInitialClientRender: GatsbyBrowser['onInitialClientRender'] = () => {
  // Refresh ScrollTrigger after initial hydration
  // Critical for production builds where timing can differ from development
  if (typeof window !== 'undefined') {
    window.requestAnimationFrame(() => {
      setTimeout(() => {
        if ((window as any).ScrollTrigger) {
          (window as any).ScrollTrigger.refresh()
        }
      }, 300) // Increased to match animation initialization delay
    })
  }
}
